import React, { useEffect, useState } from 'react';
import { PageHeader, Typography, Button, Divider, notification, message } from 'antd';
import JobCard from './JobCard';
import './../../styles/components/MarketPlace/JobListings.scss';
import { useHistory, useLocation } from 'react-router-dom';
import BottomButton from '../Buttons/BottomButton';
import ApplyJobModal from './ApplyJobModal';
import { createApplication, getJobs } from '../../services/API/MarketplaceService';
import { APPLICABLE_JOBS, JOB_DESCRIPTION, companySpecificTestimonials } from '../../constants/MarketplaceConstants';
import { Navigation } from '../../services/NavigationService';
import { Routes } from '../../constants/RouterConstants';
import GetStarted from './popups/GetStarted';
import DuplicateApplicationPopup from './popups/DuplicateApplicationPopup';
import { useMitraStore } from '../../contexts/MitraContext';
import { getCompanyTestimonial } from '../../utils/MarketplaceUtils';
import jd_testimonial from '../../assets/jd_testimonial.svg';
import ReusableReviewComponent from './ReusableReviewComponent';
import { useTranslation } from 'react-i18next';
import useMoengage from '../../hooks/useMoengage';
import moment from 'moment';
import {PhoneOutlined } from '@ant-design/icons';
// import blitz from 'blitzllama-js';

const { Text } = Typography;

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const JobDescription = () => {
  const history = useHistory();
  const [showApplyJobModal, setShowApplyJobModal] = useState(false);
  const [showGetStartedDrawer, setShowGetStartedDrawer] = useState(false);
  const [showDuplicateApplicationPopup, setShowDuplicateApplicationPopup] = useState(false);
  const [siId, setSiId] = useState('');
  const [jobData, setJobData] = useState([]);
  let query = useQuery();
  const city = query.get('city');
  const client = query.get('client');
  const applicableJobs = APPLICABLE_JOBS;
  const [jobDescription, setJobDescription] = useState({});
  const [companyTestimonial, setCompanyTestimonial] = useState({});
  const [companyTestimonialImg, setCompanyTestimonialImg] = useState(jd_testimonial);
  const { selectedJobDescription } = useMitraStore();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [, trackEvent] = useMoengage();
  const { selectedMitraDetails } = useMitraStore();

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (localStorage.getItem('jobData')) {
      setJobData(JSON.parse(localStorage.getItem('jobData')));
    } else {
      getJobs(`"${city}"`, `"${client}"`, userId)
      .then(response => {
        if (!response.data.viewData.allJobDemands.otherJobDemands.length) {
          setJobData(response.data.viewData.allJobDemands.appliedJobDemands);
        } else {
          setJobData(response.data.viewData.allJobDemands.otherJobDemands);
        }
      })
      .catch(error => {
        console.log(error);
      });
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);

    setJobDescription(selectedJobDescription);
    getClientSpecificReviewCard();
  }, []);

  const getClientSpecificReviewCard = () => {
    companySpecificTestimonials.allTestimonials.forEach((testimonial, index) => {
      if (testimonial.forCompany.toLowerCase() == client.toLowerCase()) {
        setCompanyTestimonial(testimonial);
        const clientTestimonial = getCompanyTestimonial(client);
        if(clientTestimonial) {
          setCompanyTestimonialImg(clientTestimonial);
        }
      }
    });
  };

  const viewApplicationStatus = () => {
    const route = {
      pathname: Routes.APPLICATION_STATUS,
      search: `applicationId=${jobData[0].scheduledInterviewId}&city=${localStorage.getItem(
        'preferredLocation'
      )}`,
    };
    Navigation.push(route);
    // history.replace(`/application-status?applicationId=${jobData[0].scheduledInterviewId}`);
  };

  const applyNowButton = () => {
    // this function will open the ApplyJobModal only for clients other than Zomato and Dunzo
    if (['zomato', 'zomato_3pl', 'dunzo'].includes(jobData[0].companyName.toLowerCase())) {
      // directly create the application here and move the user to application status page

      const requestPayload = {
        userId: localStorage.getItem('userId'),
        jobDemandId: jobData[0].id,
      };
      setLoading(true);
      createApplication(requestPayload)
        .then(response => {
          setLoading(false);
          // blitz.triggerEvent('jse_job_applied');
          history.replace(`/application-status?applicationId=${response?.data?.id}`);
        })
        .catch(err => {
          setLoading(false);
          setShowDuplicateApplicationPopup(true);
        });
    } else {
      setShowApplyJobModal(true);
    }
  };

  const triggerEvent = () => {
    trackEvent('jse_call_us_clicked', {
      userId: localStorage.getItem('userId'),
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
  };
  return (
    <div style={{ paddingBottom: '1px' }}>
      <PageHeader
        className="site-page-header"
        onBack={() => {
          // history.replace(`/job-listings?city=${city}`);
          const route = {
            pathname: Routes.JOB_LISTINGS,
            search: `city=${city}`,
          };
          Navigation.push(route);
        }}
        title={t('job_description')}
        extra={[
          <div className="inbound-calling-container">
            <div className="help">Need Help?</div>
            <div className="call-us">
              <a href={`tel:+91-6366783062`}>
                <Button onClick={() => triggerEvent()}>
                  <PhoneOutlined />
                  Call us
                </Button>
              </a>
            </div>
          </div>,
        ]}
      />

      <div className="job-listings-main-container no-bottom-padding">
        <div className="individual-job-listing">
          {jobData.map(job => {
            return <JobCard showCTA={false} key={job.id} jobData={job} city={city} />;
          })}
        </div>
      </div>

      <div className="jd-review-card">
        <ReusableReviewComponent
          testimonialData={companyTestimonial}
          testimonialImage={companyTestimonialImg}
        />
      </div>
      <div>
        <Divider orientation="left">
          <Text className="job-description-main-header">{t('job_description')}</Text>
        </Divider>
      </div>

      <div className="job-details-modal-container">
        {jobDescription?.earningDetailsAndBenefits?.length > 0 && (
          <div className="job-type">
            <Text className="job-detail-title">{t('earning_details_benefits')}</Text>
            <ul className="job-detail-content">
              {jobDescription?.earningDetailsAndBenefits
                ? jobDescription.earningDetailsAndBenefits.map(item => {
                    return <li key={item.id}>{item.value}</li>;
                  })
                : null}
            </ul>
          </div>
        )}

        {jobDescription?.joiningRequirements?.length > 0 && (
          <div className="salary-range">
            <Text className="job-detail-title">{t('joining_requirements')}</Text>
            <ul className="job-detail-content">
              {jobDescription?.joiningRequirements
                ? jobDescription.joiningRequirements.map(item => {
                    return <li key={item.id}>{item.value}</li>;
                  })
                : null}
            </ul>
          </div>
        )}

        {/* {
            jobDescription?.timings?.length > 0 && <div className="job-requirements">
                <Text className="job-detail-title">Requirements</Text>
                <ul className='job-detail-content'>
                {
                    jobDescription?.timings ?
                    jobDescription.timings.map(item => {
                        return <li key={item.id}>{item.value}</li>
                    }): null
                }
                </ul>
            </div>
          } */}

        {Object.keys(jobDescription).length === 0 && <Text>{t('no_data')}</Text>}
      </div>

      {/* <BottomButton
        buttonText="Apply Now"
        disabled={!applicableJobs.includes(jobData?.[0]?.companyName.toLowerCase())}
        callBackFunction={()=>{setShowApplyJobModal(true)}}
        /> */}

      {jobData?.[0]?.scheduledInterviewId ? (
        <BottomButton
          buttonText="Track Status"
          callBackFunction={() => viewApplicationStatus()}
        />
      ) : (
        <BottomButton
          buttonText="Apply Now"
          callBackFunction={applyNowButton}
          loading={loading}
        />
      )}
      <ApplyJobModal
        open={showApplyJobModal}
        close={() => setShowApplyJobModal(false)}
        jobData={jobData?.[0]}
        showGetStartedPopup={() => setShowGetStartedDrawer(true)}
        setSiId={setSiId}
        showDuplicateApplicationPopup={() => setShowDuplicateApplicationPopup(true)}
      />
      <GetStarted
        siId={siId}
        open={showGetStartedDrawer}
        close={() => setShowGetStartedDrawer(false)}
        jobData={jobData?.[0]}
      />
      <DuplicateApplicationPopup
        open={showDuplicateApplicationPopup}
        close={() => setShowDuplicateApplicationPopup(false)}
        accessOrigin={'JobDescription'}
        company={jobData?.[0]?.displayName ? jobData?.[0]?.displayName?.charAt(0).toUpperCase() + jobData?.[0]?.displayName?.slice(1):
          jobData?.[0]?.clientName?.charAt(0).toUpperCase() + jobData?.[0]?.clientName?.slice(1)}
      />
    </div>
  );
};

export default JobDescription;
